export const enum ENUM_CALENDAR {
  // disabledDays = 2,
  disabledDays = -1,
}

export const enum INTERSECTION_ELEMENTS {
  CATALOG = 30,
  CART = 5,
  ADV_PROJECTS = 10,
  ADV_PROJECT_ORDERS = 10,
  BLOGGER_OFFERS = 10,
  SELF_CONNECT_ORDERS = 10,
  BLOGGER_CHANNELS = 10,
  BLOGGER_MODERATION_CHANNELS = 10,
  HISTORY = 10,
  CHAT = 20,
  DOCUMENTS = 5,
  MANAGER_PROJECTS = 10,
  AGENCY_PROJECTS = 10,
  CHANNEL_REVIEWS = 10,
  REC_CARDS_CHANNEL = 10,
  REC_CARDS_CART = 10,
  NOTIFICATIONS = 15,
  ADMIN_CHANNELS = 10,
  ADMIN_USERS = 10,
  ADMIN_TRANSACTIONS = 10,
  ADMIN_ACCOUNTING = 10,
  ADMIN_COMPLAINTS = 5,
  ADMIN_REVIEWS = 5,
  ADMIN_MANAGE_PROJECTS = 10,
}

export const enum BREAKPOINT {
  XL = 1366,
  LG = 992,
  MD = 768,
  SM = 576,
  XS = 375,
  HEADER_NAVBAR_VISIBLE = 1400,
}
